import { TourPractice } from "./TourPractice";

const steps = [
  { target:"filamentos-novo", title:"Seu estoque de filamentos", text:"O botão + abre o cadastro. Use material, cor, quantidade em gramas e custo por quilo reais. Você pode cadastrar agora ou continuar sem criar nada — não é necessário adicionar rolos de exemplo." },
  { target:"filamentos-lista", title:"Estoque pronto para o cálculo", text:"Os filamentos cadastrados aparecem na calculadora. Ao importar um arquivo, associe cada cor ao rolo correto. Peso usado e custo por quilo determinam o custo do material." },
];
export function TourFilamentoInteractive({ onDone }) {
  return <TourPractice steps={steps} onDone={onDone} />;
}
